<template>
  <div class="error_message_container">
    <span class="error_text">
      {{ $t("k_4dec3fe") }}
    </span>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.error_message_container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .error_text{
    color:var(--wuji-primary-color);
  }
}
</style>
